import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { List, fromJS } from 'immutable';
import Modal from 'components/base/Modal';
import Button from 'components/base/Button';
import ContactSearchTable from 'app/components/SearchTable/ContactSearchTable';
import PropertySearchTable from 'app/components/SearchTable/PropertySearchTable';
import classNames from 'classnames';
import { getPopupRegistration, openPopup, Priority } from 'app/PopupHolder';
import { MAIN_CONTEXT, AVAILABLE_CONTEXT, ASSIGNED_CONTEXT, assignedGroupId, getGroupOptions } from 'reducers';
import { pluralize } from 'utils/string';
import * as Property from 'data/property';
import * as Contact from 'data/contacts';
import SVG from 'components/base/SVG';

import css from './style.scss';
import { CampaignDropdown } from '../../../components/base/Dropdown';


let i = 0;

class GroupAssignmentEditor extends PureComponent {
  constructor(props) {
    super(props);

    this.handleClose = this.handleClose.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleRemoveClick = this.handleRemoveClick.bind(this);
    this.handleGroupChange = this.handleGroupChange.bind(this);
    this.handleAddClick = this.handleAddClick.bind(this);

    const { ids = [], groupId = null } = this.props;

    this.state = { id: null, loadId: groupId, loadIds: ids.length ? ids : null, assignedContextDataIds: null, isAssigning: false };
  }

  componentDidMount() {
    const { loadGroupContext, viewMode } = this.props;

    if (viewMode) {
      loadGroupContext(ASSIGNED_CONTEXT, assignedGroupId);
    } else {
      loadGroupContext(MAIN_CONTEXT, 0, { filterEnabled: true });
      loadGroupContext(ASSIGNED_CONTEXT, assignedGroupId);
      loadGroupContext(AVAILABLE_CONTEXT);
    }

    this.handleProps(this.props);
  }

  componentWillReceiveProps(props) {
    this.handleProps(props);
  }

  handleProps(props) {
    const { searchGroupContext, loading, loadContextIds, availableContext, assignedContext, loadGroupContext, viewMode } = props;
    const { id, loadId, loadIds } = this.state;

    if (!loading) {
      if (loadIds) this.setState({ loadIds: null }, () => loadContextIds(assignedContext, loadIds));
      else if (loadId) this.setState({ loadId: null, id: loadId }, () => loadGroupContext(AVAILABLE_CONTEXT, loadId, { limit: 0 }));
      else if (!viewMode && id && availableContext.get('size') == null && i++ < 100) searchGroupContext(availableContext);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.assignedContext?.get("data") && prevProps.assignedContext?.get("data") !== this.props.assignedContext?.get("data")) {
      this.setState({ assignedContextDataIds: this.props.assignedContext.get("data").filter((item) => item.has("id") && item.get("id") != null).map((item) => item.get("id")) });
    }
  }

  handleClose() {
    this.props.closePopup();
  }

  handleAddClick() {
    this.setState({ isAssigning: true });

    const assignFn = this.props.assignContextAsync || this.props.assignContext;

    const result = this.props.assignContextAsync ? assignFn({}, this.state.assignedContextDataIds) : assignFn();

    if (result && typeof result.finally === 'function') {
      result.finally(() => this.setState({ isAssigning: false }));
    } else {
      this.setState({ isAssigning: false });
    }
  }


  handleRemoveClick() {
    this.props.unassignContext();
  }

  handleSave() {
    const { onSave, assignedContext } = this.props;
    if (onSave) onSave((assignedContext.getIn(['info', 'ids']) || List()).toJS());
    this.handleClose(this);
  }

  handleGroupChange(event) {
    const { value: selectedGroup } = event.target;
    const { groups, loadGroupContext } = this.props;
    const id = groups.getIn([selectedGroup, 'id']);

    i = 0;
    this.setState({ id }, () => loadGroupContext(AVAILABLE_CONTEXT, id, { limit: 0 }));
  }

  render() {
    const {
      type,
      assignedContext,
      loading,
      groups,
      viewMode,
      groupId,
      SearchTable,
    } = this.props;

    const filteredAvailableContext = () => {
      const { availableContext, assignedContext, campaignEdit } = this.props;
      if (!campaignEdit) return availableContext
      const newContext = availableContext
      if (!newContext || !newContext.get('data') || !newContext.get('data').size) return newContext;
      if (!assignedContext || !assignedContext.get('data') || !assignedContext.get('data').size) return newContext;

      const assignedIds = assignedContext.get('data').map(item => item.get('id')).toSet();
      const filteredData = newContext.get('data').filter(item => !assignedIds.has(item.get('id')));
      const filteredSize = filteredData.size;

      // Count selected items in filtered data
      const filteredSelected = filteredData.filter(item => item.get('selected')).size;

      return newContext
        .set('data', filteredData)
        .set('size', filteredSize)
        .set('selected', filteredSelected);
    }

    const availableContext = filteredAvailableContext()

    const btn = { kind: Button.kind.blue, size: Button.size.large, className: css.btn, isLoading: loading };

    const assignedSize = assignedContext.get('size');
    const typeName = pluralize(type);

    const getButtonText = () => {
      if (loading) return 'Loading...';
      if (this.state.isAssigning) return <SVG icon="spinner" className={classNames(css.spinner)} />;
      return `Add Selected Leads`;
    };

    let updatedAvailableContext = availableContext;
    if (availableContext?.get("size") != null && availableContext.get("data").size > 0
      && assignedContext?.get("size") != null && assignedContext.get("data").size > 0) {
      const assignedDataRowIds = assignedContext.get("data").map(item => item.get("id"));

      const filteredData = availableContext.get("data").filter(item => !item || !item.has("id") || !assignedDataRowIds.includes(item.get("id")));
      const removedDataSize = availableContext.get("data").size - filteredData.size;
      const remaining = Math.max(availableContext.has("remaining") ? availableContext.get("remaining") - removedDataSize : 0, 0);
      const selection = availableContext.has("selection") ? availableContext.get("selection").filter(dataRowId => !assignedDataRowIds.includes(dataRowId)) : availableContext.get("selection");

      updatedAvailableContext = availableContext
        .set("data", filteredData)
        .set("remaining", remaining)
        .set("selected", selection?.size ?? 0)
        .set("selection", selection);
    }

    const availableSelected = updatedAvailableContext.get('selected');
    const availableSize = updatedAvailableContext.get("data").size;

    return (
      <Modal
        isOpen
        uniqId="groupAssignment"
        caption={<div className={css.header}>{viewMode ? 'View' : 'Edit'} Leads</div>}
        width={viewMode ? "1316px" : "1402px"}
        height={viewMode ? "590px" : "auto"}
        background={viewMode ? "#EFF2F6" : "#fff"}
        padding={viewMode ? "21px 21px 21px 24px" : "25px 20px"}
        border={viewMode ? "transparent" : undefined}
        modalClassName={classNames(css.contactsModal, { [css.viewLeadsModal]: viewMode })}
      >
        <div className={viewMode ? `${css.body} ${css.viewBody}` : css.body}>
          <div className={css.recipientContainer}>
            {viewMode ? null : (
              <div className={css.recipientRow}>
                <div className={css.assignmentContainer}>
                  <div>
                    <label>Available Leads:</label>
                    {!availableContext.get('id') ? null : <div className={css.remaining}>{!availableSize ? null : `${availableSize} Remaining`}</div>}
                  </div>
                  <CampaignDropdown groups={getGroupOptions(groups)} onChange={this.handleGroupChange} value={groups.findIndex(g => g.get('id') === this.state.id)} className={css.dropDown} disabled={loading || groupId} showLabel={false} />
                  <div >
                    <Button
                      style={{ marginTop: '10px' }}
                      {...{ ...btn, kind: Button.kind.blueLink, className: css.blueLink }}
                      disabled={!availableSelected || this.state.isAssigning || loading}
                      onClick={this.handleAddClick}
                    >
                      {getButtonText()}
                    </Button>
                  </div>
                  {!availableSelected ? null : (<div className={css.remaining}>{availableSelected} Selected</div>)}
                </div>
                <div className={css.tableContainer}>
                  <div className={classNames(css.tableWrapper, { [css.freeze]: this.state.isAssigning })}>
                    {type === "Contact"
                      ? <ContactSearchTable context={updatedAvailableContext} />
                      : <SearchTable context={availableContext} />}
                    {(loading || this.state.isAssigning) && (
                      <div className={css.tableLoader}>
                        <SVG icon="spinner" className={classNames(css.spinner)} />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            <div className={classNames(css.recipientRow, { [css.full]: viewMode })}>
              <div className={css.assignmentContainer}>
                <div className={css.title}>Selected Leads {!assignedSize ? null : `(${assignedSize})`}</div>
              </div>
              {/* viewTableContainer hides scrollbars in view mode only */}
              <div className={viewMode ? css.viewTableContainer : css.tableContainer}>
                <div className={classNames(css.tableWrapper, { [css.freeze]: this.state.isAssigning })}>
                  {type === "Contact"
                    ? <ContactSearchTable context={assignedContext} viewMode={viewMode} />
                    : <SearchTable context={assignedContext} viewMode={viewMode} />}
                  {(this.state.isAssigning || loading) && (
                    <div className={css.tableLoader}>
                      <SVG icon="spinner" className={classNames(css.spinner)} />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={viewMode ? css.viewFooter : css.footer}>
          <div>
            {!viewMode && (
              <button
                onClick={this.handleRemoveClick}
                disabled={
                  !assignedContext.get('selected') ||
                  this.state.isAssigning ||
                  loading
                }
                className={css.removeselected}
              >
                Remove Selected
              </button>
            )}
          </div>
          <div style={{ display: "flex" }}>
            <button
              className={`${css.btncontainer} ${css.btnCancel}`}
              disabled={this.state.isAssigning}
              onClick={this.handleClose}
            >
              {viewMode ? 'Close' : 'Cancel'}
            </button>

            {!viewMode && (
              <button
                className={`${css.btncontainer} ${css.btnSave}`}
                disabled={this.state.isAssigning || loading}
                onClick={this.handleSave}
              >
                Done
              </button>
            )}
          </div>
        </div>
      </Modal>
    );
  }
}

GroupAssignmentEditor.propTypes = {
  title: PropTypes.string.isRequired,
  viewMode: PropTypes.bool.isRequired,
  groupId: PropTypes.string,
};

GroupAssignmentEditor.defaultProps = {
  title: 'Edit Recipients',
  viewMode: false,
};

export default GroupAssignmentEditor;

const GroupsAssignmentPopup = (Type, SearchTable, type) => {
  const popup = connect(state => ({
    loading: Type.selectLoading(state),
    groups: Type.selectGroups(state),
    availableContext: Type.selectGroupContext(AVAILABLE_CONTEXT)(state),
    assignedContext: Type.selectGroupContext(ASSIGNED_CONTEXT)(state),
  }), {
    loadGroupContext: Type.loadGroupContext,
    loadContextIds: Type.loadContextIds,
    searchGroupContext: Type.searchGroupContext,
    assignContext: Type.assignContext,
    assignContextAsync: Type.assignContextAsync,
    unassignContext: Type.unassignContext,
  })(GroupAssignmentEditor);

  popup.open = (props = {}) => openPopup(getPopupRegistration(popup), { ...props, SearchTable, type, priority: Priority.HIGH });

  return popup;
};

export const ContactAssignmentPopup = GroupsAssignmentPopup(Contact, ContactSearchTable, 'Contact');
export const PropertyAssignmentPopup = GroupsAssignmentPopup(Property, PropertySearchTable, 'Property');
